<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem }"
    custom-export-url="/show-rooms/export/"
    has-availabilities
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.room"
            :error-messages="error.room"
            :model="roomModel"
            item-text="room__full__name"
            item-value="id"
            label="Stanza"
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="editedItem.status"
            :error-messages="error.status"
            :items="[
              { value: 1, text: 'selezionato' },
              { value: 2, text: 'contattato' },
              { value: 3, text: 'approvato' },
            ]"
            label="Stato"
          ></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.cost"
            :error-messages="error.cost"
            label="Costo"
            type="number"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.notes"
            :error-messages="error.notes"
            label="Note"
          ></v-text-field>
        </v-col>
      </v-row>
      <ul v-if="editedItem.warnings && editedItem.warnings.length > 0">
        <li
          v-for="warning in editedItem.warnings"
          :key="warning"
          class="red--text"
        >
          <template v-if="warning.type == 'room_booking_overlap'">
            Sovrapposizione prenotazioni per la stessa camera
          </template>
          <template v-else-if="warning.type == 'room_capacity_exceeded'">
            Numero ospiti ({{ warning.guests_total }}) supera capacità della camera ({{ warning.room_capacity }})
          </template>
          <template v-else-if="warning.type == 'booking_outside_room_availability_range'">
            Prenotazione fuori dal range di disponibilità della camera
          </template>
          <template v-else-if="warning.type == 'booking_outside_person_availability_range'">
            Prenotazione fuori dal range di disponibilità della persona {{ warning.person }}
          </template>
        </li>
      </ul>
    </template>

    <template v-slot:item.status="{ item }">
      <status-indicator small :status="item.status" />
    </template>

    <template v-slot:item.warnings="{ item }">
      <v-icon v-if="item.warnings.length > 0">
        fa fa-exclamation-triangle
      </v-icon>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"
import statuses from "@/statuses"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Stanza", value: "room__name" },
        { text: "Stato", value: "status" },
        { text: "Alert", value: "warnings" },
      ],
      model: models.ShowRoom,
      roomModel: models.Room,
      statuses,
      showHotels: [], // To store the related show hotels
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  created() {
    this.fetchShowHotels()
  },
  methods: {
    fetchShowHotels() {
      const showId = this.$route.params.id
      // Fetch the show hotels related to the current show using Vuex action
      this.$store
        .dispatch("listShowHotels", { showId })
        .then((showHotels) => {
          this.showHotels = showHotels
        })
    },
    filterRooms(room) {
      // Get the hotel IDs from the show hotels
      const hotelIds = this.showHotels.map((showHotel) => showHotel.hotel)
      // Filter rooms based on the hotel IDs
      const result = hotelIds.includes(room.hotel)
      return result
    },
    defaultItem: () => ({
      availabilities: [],
      room: null,
      cost: 0,
      notes: "",
    }),
  },
}
</script>
